import React, { JSX } from 'react';

import { ViewStyle } from 'react-native';

import Animated, {
    Extrapolate,
    interpolate,
    useAnimatedStyle,
} from 'react-native-reanimated';
import { useSelector } from 'react-redux';

import { selectBackground } from 'store/config/selectors.layout';

import useHeaderHeight from 'utils/hooks/useHeaderHeight';
import { isAndroid15 } from 'utils/responsiveness';

import styles from './styles';

type Props = {
    scrollPosition: Animated.SharedValue<number>;
    insets?: boolean;
    children?: JSX.Element | JSX.Element[];
    style?: ViewStyle | ViewStyle[];
};

function AnimatedHeaderBackground({
    scrollPosition,
    insets = true,
    style,
    children,
}: Props) {
    const backgroundColor = useSelector(selectBackground);
    const headerHeight = useHeaderHeight(insets);
    const animatedStyles = useAnimatedStyle(() => ({
        opacity: interpolate(scrollPosition.value, [0, headerHeight], [0, 1], {
            extrapolateLeft: Extrapolate.CLAMP,
            extrapolateRight: Extrapolate.CLAMP,
        }),
    }));

    return (
        <Animated.View
            style={[
                styles.root,
                animatedStyles,
                {
                    height: headerHeight,
                    backgroundColor,
                },
                insets && isAndroid15 && styles.rootWithInsets,
                style,
            ]}
        >
            {children}
        </Animated.View>
    );
}

export default AnimatedHeaderBackground;
